import { createSelector } from '@reduxjs/toolkit';
import { RootStateType } from 'App/ReduxProvider/store';

export const getStoreInfo = createSelector(
  (state: RootStateType) => state.storeInfo,
  (storeInfo) => storeInfo,
);
